import { gql } from '@apollo/client';

export const ALL_INSTITUTION_INSIGHTS = gql`
  query allInstitutionInsights($input: getInsightsInput!) {
    insights: allInstitutionInsights(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          users {
            id
            firstName
            lastName
          }
          tags {
            id
            name
          }
          url
          createdBy {
            id
            firstName
            lastName
          }
          createdOn
        }
      }
    }
  }
`;
